import {inject, Injectable} from '@angular/core'
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {
  propertyLazySelectApprovalStatus,
  qualityControlApprovalsResourceType
} from "../configs/quality-control-approvals-config";
import {
  GetSelectDataParams,
  RecordUpdateRequestParams,
  SelectData
} from "../../../../../../../core/types/records-table.types";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {CreateQualityControlApprovalsData, QualityControlApprovalsData} from "../types/quality-control-approvals.types";

@Injectable({
  providedIn: 'root'
})
export class QualityControlApprovalsService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public getDataInModal<T>(productCardQualityControlId: number): Promise<Array<T>> {
    const params = {
      path: `${qualityControlApprovalsResourceType.path}/`,
      queryParams: {
        productCardQualityControlId: productCardQualityControlId
      }
    };

    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public createQualityControlApprovalsData(createFactoryBankDetails: CreateQualityControlApprovalsData): Promise<QualityControlApprovalsData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateQualityControlApprovalsData, QualityControlApprovalsData>(createFactoryBankDetails, qualityControlApprovalsResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(params: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(params).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public getSelectData(): Promise<Array<SelectData>> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectApprovalStatus
    };

    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    })
  }
}
